(function(){
  function dds(){return [].slice.call(document.querySelectorAll('[data-dd]'));}
  document.addEventListener('click',function(e){
    dds().forEach(function(d){ if(d.open && !d.contains(e.target)) d.open=false; });
  });
  document.addEventListener('keydown',function(e){
    if(e.key!=='Escape') return;
    dds().forEach(function(d){ if(d.open){ d.open=false; var s=d.querySelector('summary'); if(d.contains(document.activeElement)&&s) s.focus(); } });
  });
  document.addEventListener('toggle',function(e){
    var t=e.target; if(!t.matches||!t.matches('[data-dd]')||!t.open) return;
    dds().forEach(function(d){ if(d!==t) d.open=false; });
  },true);
})();
